import axios from "axios";
import { store } from "../store/store";
const pako = require('pako');

export default async function checkStatus() {
  store.commit("incrementCarregando", true);
  try {
    const res = await axios({
      withCredentials: true,
      method: "get",
      url: `${process.env.VUE_APP_APIURL}/user/checkStatus`,
    });
    store.commit("incrementCarregando", false);
    let data = res.data.result;
    let inflatedData = JSON.parse(pako.inflate(new Uint8Array(data.data), { to: 'string' }));
    res.data.result = inflatedData
    return res
  } catch (error) {
    store.commit("incrementCarregando", false);
    return error.response;
  }
}
